/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialExportTransaction
 */
export interface FinancialExportTransaction {
    /**
     * 
     * @type {string}
     * @memberof FinancialExportTransaction
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialExportTransaction
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialExportTransaction
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof FinancialExportTransaction
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialExportTransaction
     */
    createdAt?: number;
}

/**
 * Check if a given object implements the FinancialExportTransaction interface.
 */
export function instanceOfFinancialExportTransaction(value: object): value is FinancialExportTransaction {
    return true;
}

export function FinancialExportTransactionFromJSON(json: any): FinancialExportTransaction {
    return FinancialExportTransactionFromJSONTyped(json, false);
}

export function FinancialExportTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialExportTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'type': json['type'] == null ? undefined : json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function FinancialExportTransactionToJSON(json: any): FinancialExportTransaction {
    return FinancialExportTransactionToJSONTyped(json, false);
}

export function FinancialExportTransactionToJSONTyped(value?: FinancialExportTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'subject': value['subject'],
        'type': value['type'],
        'amount': value['amount'],
        'createdAt': value['createdAt'],
    };
}

